import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemWebhooksRoute: InvariantJiraRoute = {
	name: 'global-settings-system-webhooks',
	path: '/plugins/servlet/webhooks',
};
